import { ReactElement, useState } from 'react'
import { Tooltip } from '/app/components/Tooltip'
/**
 * This is a component that can be used in ControlledComponents where different outcomes may occur
 * depending on business rules. Eg, in the Contacts table, fields like utmSource, utmMedium, or channel
 * may vary. If the user is SMC, it renders a common cell with content inside a tooltip like any other table cell.
 * If the user is not SMC, it renders a cell with very specific logic.
 * @param {string | undefined} props.value - The value to be displayed in the tooltip.
 * @returns {ReactElement} - The rendered TooltipWrapper component.
 */
export default function TooltipWrapper({ value }: { value?: string }): ReactElement {
  const [message, setMessage] = useState<string | undefined>(undefined)
  return (
    <div className="inline-flex w-full items-center px-2">
      <Tooltip
        message={message}
        className="truncate"
        onMouseOver={(event) => {
          if (
            event.currentTarget instanceof HTMLElement &&
            event.currentTarget.scrollWidth > event.currentTarget.clientWidth
          ) {
            setMessage(value)
          } else setMessage(undefined)
        }}
      >
        <>{value}</>
      </Tooltip>
    </div>
  )
}
